import { Protocol } from '../Protocol';

export class SampleSourceProtocol {
  public static readonly ALL_SAMPLE_SOURCE: string = `${Protocol.YATUNG_API_ROOT}/source/sample/all`;
}
